import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/normandie.svg")